import { getIdFromPath } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { NotAllowed } from "../components/not-allowed";
import { ConnectionsEditPage } from "./connections-edit-page";
import { ConnectionsPage } from "./connections-page";

export const ConnectionsRouter = () => {
    const current = getIdFromPath(3);
    const id = getIdFromPath(4);
    return <>
        {
            !current && Can(UserEntitlementCatalogs.ViewConnectionsTab) ? <ConnectionsPage /> :
                current === 'new' && Can(UserEntitlementCatalogs.ViewCreateNewConnectionsButton) ? <ConnectionsEditPage /> :
                    current === 'edit' && Can(UserEntitlementCatalogs.EditConnectionsPage) && id !== '' ? <ConnectionsEditPage id={id} /> :
                        <NotAllowed />
        }
    </>
}
